<script>
import resources from './resources'
import {TheMask} from 'vue-the-mask'
import '@desislavsd/vue-select/dist/vue-select.css'

export default {
  name: 'profile',
  mixins: [resources],
  components: {
    TheMask
  }
}
</script>


<template lang="pug">
  section.content.profile-page
    page
    .container-fluid
      .block-header
        .row.clearfix
          .col-lg-5.col-md-5.col-sm-12
            h2 Perfil
            ul.breadcrumb.padding-0
              li.breadcrumb-item
                a(href='index.html')
                  i.zmdi.zmdi-home
              li.breadcrumb-item
                a(href='javascript:void(0);') {{ user.name}}
              li.breadcrumb-item.active Perfil
          //-.col-lg-7.col-md-7.col-sm-12
            .input-group.m-b-0
              input.form-control(type='text', placeholder='Search...')
              span.input-group-addon
                i.zmdi.zmdi-search
      .row.clearfix
        .col-lg-12.col-md-12
          .card
            .body.bg-dark.profile-header
              .row(style="min-height: 115px;")
                .col-lg-10.col-md-12
                  div.cursor-pointer#uploadAvatar
                    img.user_pic.rounded.img-raised(
                      v-if="user.image !== null"
                      :src='user.image', alt='User',
                      style="width: 180px;"
                    )
                    img.user_pic.rounded.img-raised(
                      v-if="user.image === null"
                      src='/static/images/profile_av.jpeg',
                      alt='User'
                      style="width: 180px;"
                    )
                  .row
                    f-avatar
                  .detail
                    .u_name
                      h4
                        strong {{ user.name}}
                      span {{ getTypeUser() }}

                //-.col-lg-2.col-md-12.user_earnings
                  h6 Total Earnings
            ul.nav.nav-tabs.profile_tab
              li.nav-item
                router-link.nav-link.cursor-pointer(:to="{name: 'dweller.profile.overview.me'}") Visão Geral
              li.nav-item
                router-link.nav-link.cursor-pointer(:to="{name: 'dweller.profile.schedules.me'}") Agendamentos
              li.nav-item
                a.nav-link.cursor-pointer.active(data-toggle='tab') Perfil
          .tab-content
            account-settings
</template>
<style>
.cursor-pointer {
  cursor: pointer;
}
.v-select .v-select-bar {
    position: relative;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    white-space: nowrap;
    margin-bottom: calc(0px - var(--padd));
    padding-left: 7px;
    width: 100%;
}
.v-select {
    position: relative;
    outline: none;
    border: 1px solid #E3E3E3;
    border-radius: 30px;
}
.v-select {
  word-spacing: normal;
  text-transform: none;
  text-indent: 0px;
  text-shadow: none;
  font: 400 12px system-ui;
}
.v-select .v-select-option {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: .3em .5em;
  cursor: pointer;
  margin-right: 34px;
  border-radius: 30px;
}
.v-select .v-select-selected:first-of-type {
    padding-left: 14px;
}

@media screen and (max-width: 768px) {
  .nav-tabs .nav-item {
      margin-bottom: -1px;
      width: 100%;
      margin-bottom: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/dweller/profile/me/me.vue